import { useTalentInfo } from "@/api/services/main/talent";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { TalentDetailContent } from "@/features/talent/components/talent-detail/TalentDetailContent";
import { convertResToFormData } from "@/features/talent/utils/convertTalentFormData";
import { useValidateId } from "@/hooks/useValidateId";
import { AppRoutes } from "@/routes/config";

const TalentDetail = () => {
  const queryResult = useTalentInfo();
  const { data, isLoading } = queryResult;
  useValidateId("talentId", AppRoutes.talentList, queryResult);

  if (!data || isLoading) return <LoadingPage />;

  return <TalentDetailContent defaultValues={convertResToFormData(data.data)} />;
};

export default TalentDetail;
